// extracted by mini-css-extract-plugin
module.exports = {"btn":"Paginado_btn___IiPy","btnSelected":"Paginado_btnSelected__RuvTb","content":"Paginado_content__3URsn"};